<template>
  <div class="clearfix">
    <vs-input
      v-validate="'required|phone:mobile'"
      data-vv-validate-on="blur"
      name="phone"
      :label-placeholder="$t('users.phone')"
      :data-vv-as="$t('users.phone')"
      v-model="phone"
      @keyup="phone = translateNumbers(phone)"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first('phone') }}</span>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:8'"
          name="password"
          :label-placeholder="$t('users.password')"
          :data-vv-as="$t('users.password')"
          v-model="password"
          class="w-full mt-6"
        />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>
      </div>

      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          type="password"
          v-validate="'min:8|confirmed:password'"
          data-vv-validate-on="blur"
          name="confirmPassword"
          :label-placeholder="$t('auth.confirm_password')"
          :data-vv-as="$t('auth.confirm_password')"
          v-model="confirmPassword"
          class="w-full mt-6"
        />
        <span class="text-danger text-sm">{{ errors.first('confirmPassword') }}</span>
      </div>
    </div>
    <div class="vx-row ">
      <div class="vx-col mb-3" :class="{ 'w-1/2 mt-6': !referralCode, 'w-full': referralCode }">
        <v-select
          :clearable="false"
          v-validate="'required'"
          data-vv-validate-on="blur"
          v-model="gender"
          name="gender"
          :placeholder="$t('users.genders.gender')"
          :data-vv-as="$t('users.genders.gender')"
          :options="genderOptions"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
      </div>
      <div class="vx-col w-1/2" v-if="!referralCode">
        <vs-input
          v-validate="'min:6|max:8'"
          data-vv-validate-on="blur"
          name="affiliate"
          :label-placeholder="$t('affiliate.affiliate_code')"
          :data-vv-as="$t('affiliate.affiliate_code')"
          v-model="affiliate"
          @keyup="affiliate = translateNumbers(affiliate)"
          class="w-full mt-6"
        />
        <span class="text-danger text-sm">{{ errors.first('affiliate') }}</span>
      </div>
    </div>
    <div v-if="referralCode">
      <vs-alert color="success">{{
        $t('affiliate.registering_with_referral_code', { code: referralCode })
      }}</vs-alert>
    </div>

    <vx-card no-shadow card-border class="mt-6 vs-row">
      <span>{{ $t('messages.pre_terms_read') }}</span>
      <a href="https://www.30teb.app/regulation" target="_blank">{{ $t('messages.terms_read') }}:</a>
      <vs-checkbox v-model="isTermsConditionAccepted" class="mt-2">{{
        $t('messages.terms_and_conditions')
      }}</vs-checkbox>
    </vx-card>
    <vs-button type="border" to="/pages/login" class="mt-6">{{ $t('button.log_in') }}</vs-button>
    <vs-button
      id="button-with-loading"
      class="vs-con-loading__container float-right mt-6"
      @click="registerUserJWt"
      :disabled="!validateForm || disabled_btn"
    >
      {{ $t('button.register') }}
    </vs-button>
  </div>
</template>

<script>
import { TranslateNumbers } from '@/utils'

export default {
  data() {
    return {
      backgroundLoading: 'primary',
      colorLoading: '#fff',
      confirmPassword: '',
      disabled_btn: false,
      gender: null,
      isTermsConditionAccepted: false,
      password: '',
      phone: '',
      affiliate: ''
    }
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.isTermsConditionAccepted === true &&
        this.phone !== '' &&
        this.password !== '' &&
        this.confirmPassword !== '' &&
        this.gender.value
      )
    },
    genderOptions() {
      return [
        { label: this.$t('users.genders.male'), value: 'male' },
        { label: this.$t('users.genders.female'), value: 'female' },
        { label: this.$t('users.genders.other'), value: 'other' }
      ]
    },
    referralCode() {
      return sessionStorage.getItem('referralCode')
    }
  },
  methods: {
    registerUserJWt() {
      this.disabled_btn = true
      // Loading
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-with-loading',
        scale: 0.45
      })
      // If form is not validated or user is already login return
      if (!this.validateForm) return

      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            phone: this.phone,
            password: this.password,
            confirmPassword: this.confirmPassword,
            details: {
              gender: this.gender.value
            }
          }
          this.$store
            .dispatch('auth/registerUserJWT', payload)
            .then(() => {
              sessionStorage.setItem('password', this.password)
              // Redirect User
              this.$router.push({ name: 'page-confirmation', params: { phone: this.phone } })

              this.$notifySuccess(this.$t('messages.verification_sent'))
              if (this.affiliate || this.referralCode) {
                const code = this.affiliate || this.referralCode
                switch (code.length) {
                  case 6:
                    this.$store
                      .dispatch('affiliate/createAffiliate', {
                        from: this.affiliate || this.referralCode,
                        phone: this.phone,
                        level: 'pending'
                      })
                      .then(res => {
                        sessionStorage.removeItem('referralCode')
                        sessionStorage.setItem('referralAffiliate', JSON.stringify(res.data))
                      })
                    break
                  case 8:
                    sessionStorage.setItem('giftCode', code)
                    break
                }
              }
            })
            .finally(() => {
              this.$vs.loading.close('#button-with-loading > .con-vs-loading')
              this.disabled_btn = false
            })
        }
      })
    },
    translateNumbers(val) {
      return TranslateNumbers(val)
    }
  }
}
</script>
